import { CKEditor } from '@ckeditor/ckeditor5-react'
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Alignment,
  FontColor,
  FontBackgroundColor,
  Table,
  TableToolbar,
  FontSize,
  FontFamily,
  Heading,
  ImageBlock,
  ImageCaption,
  ImageInline,
  ImageInsert,
  ImageInsertViaUrl,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Link,
  LinkImage,
  AutoLink,
} from 'ckeditor5'
import { FormCKEditorType, FormFieldProps } from './type'

import 'ckeditor5/ckeditor5.css'
import { api } from '@/api'

export const FormCKEditorField = ({
  data,
  field,
}: FormFieldProps<FormCKEditorType>) => {
  const uploadAdapter = (loader) => {
    return {
      upload: async () => {
        try {
          const file = await loader.file

          const res = await api().assets.uploadCreate({
            file,
          })
          return {
            default: res.path,
          }
        } catch (error) {
          throw error
        }
      },
    }
  }

  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (
      loader: any,
    ) => {
      return uploadAdapter(loader)
    }
  }

  return (
    <div className="w-full">
      <style>
        {`
          .ck-editor__editable {
            min-height: 240px;
            max-height: 240px;
          }

          .ck-editor__editable p {
            margin-bottom: 1rem;
            margin-top: 1rem;
          }
        `}
      </style>
      <CKEditor
        data={field.value ?? ''}
        onChange={(event, editor) => {
          const data = editor.getData()
          field.onChange(data)
        }}
        editor={ClassicEditor}
        config={{
          licenseKey: 'GPL',
          extraPlugins: [uploadPlugin],
          plugins: [
            Essentials,
            Paragraph,
            Bold,
            Italic,
            Underline,
            Strikethrough,
            Alignment,
            FontColor,
            FontBackgroundColor,
            TableToolbar,
            Table,
            FontSize,
            FontFamily,
            Heading,
            ImageBlock,
            ImageCaption,
            ImageInline,
            ImageInsert,
            ImageInsertViaUrl,
            ImageResize,
            ImageStyle,
            ImageTextAlternative,
            ImageToolbar,
            ImageUpload,
            Link,
            LinkImage,
            AutoLink,
          ],
          toolbar: [
            'fontFamily',
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'undo',
            'redo',
            '|',
            'alignment:left',
            'alignment:center',
            'alignment:right',
            'alignment:justify',
            '|',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'link',
            'insertImage',
            'insertTable',
          ],
          balloonToolbar: ['bold', 'italic', '|', 'link', 'insertImage'],
          image: {
            toolbar: [
              'toggleImageCaption',
              'imageTextAlternative',
              '|',
              'imageStyle:inline',
              'imageStyle:wrapText',
              'imageStyle:breakText',
              '|',
              'resizeImage',
              'linkImage',
            ],
          },
          link: {
            decorators: {
              openInNewTab: {
                mode: 'manual',
                label: '새 탭에서 열기',
                defaultValue: true,
                attributes: {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                },
              },
              download: {
                mode: 'manual',
                label: '다운로드',
                attributes: {
                  download: 'download',
                },
              },
            },
          },
        }}
      />
      {data.imageAlertText && (
        <p className="text-sm text-blue-500">{data.imageAlertText}</p>
      )}
    </div>
  )
}
